export const createMeta = vm => ({
  title: `Checkout - ${vm.storeInfo?.name}`,
  meta: {
    pageTitle: { name: 'Page Title', content: `Checkout - ${vm.storeInfo?.name}` },
  },
})
